var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMineral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E9FBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2201_19926",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2201_19926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 21.25C15.8113 21.25 15.6279 21.2083 15.4502 21.125C15.2724 21.0417 15.1168 20.9222 14.9835 20.7667L9.8835 14.6667C9.7835 14.5444 9.7085 14.4111 9.6585 14.2667C9.6085 14.1222 9.5835 13.9722 9.5835 13.8167C9.5835 13.7167 9.59183 13.6139 9.6085 13.5083C9.62516 13.4028 9.66127 13.3056 9.71683 13.2167L10.9668 10.7333C11.0891 10.5111 11.2529 10.3333 11.4585 10.2C11.6641 10.0667 11.8946 10 12.1502 10H19.8502C20.1057 10 20.3363 10.0667 20.5418 10.2C20.7474 10.3333 20.9113 10.5111 21.0335 10.7333L22.2835 13.2167C22.3391 13.3056 22.3752 13.4028 22.3918 13.5083C22.4085 13.6139 22.4168 13.7167 22.4168 13.8167C22.4168 13.9722 22.3918 14.1222 22.3418 14.2667C22.2918 14.4111 22.2168 14.5444 22.1168 14.6667L17.0168 20.7667C16.8835 20.9222 16.7279 21.0417 16.5502 21.125C16.3724 21.2083 16.1891 21.25 16.0002 21.25ZM14.4168 13.3333H17.5835L16.5835 11.3333H15.4168L14.4168 13.3333ZM15.3335 19.1167V14.6667H11.6335L15.3335 19.1167ZM16.6668 19.1167L20.3668 14.6667H16.6668V19.1167ZM19.0668 13.3333H20.8335L19.8335 11.3333H18.0668L19.0668 13.3333ZM11.1668 13.3333H12.9335L13.9335 11.3333H12.1668L11.1668 13.3333Z",
    fill: "#00A7A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMineral);
export default __webpack_public_path__ + "static/media/mineral.ea76f59b3ad75be0bd18bd454d21ce48.svg";
export { ForwardRef as ReactComponent };